import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import menus from './menus/menus';
import sections from './sections/sections';
import items from './items/items';
import options from './options/options';
import tags from './tags/tags';
import auth from './auth/auth';
import search from './search/search';
import suites from './suites/suites';
import events from './events/events';
import eventSuites from './event-suites/event-suites';
import eventTypes from './event-types/event-types';
import suiteOwners from './suite-owners/suite-owners';
import equipment from './equipment/equipment';
import changeHistory from './change-history/change-history';
import orders from './orders/orders';
import dashboard from './dashboard/dashboard';
import announcements from './announcements/announcements';
import subsidies from './subsidies/subsidies';
import customQuestions from './custom-questions/custom-questions';
import inquiryForm from './inquiry-form/inquiry-form';
import ui from './ui/ui';
import users from './users/users';
import bulkEdit from './bulk-edit/bulk-edit';
import rallyIntelligence from './rally-intelligence/rally-intelligence';
import cateringBot from './catering-bot/catering-bot';
import { createBulkJobModule } from './bulk-job/module';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
	modules: {
		auth,
		menus,
		sections,
		items,
		options,
		tags,
		search,
		suites,
		events,
		eventSuites,
		eventTypes,
		suiteOwners,
		equipment,
		changeHistory,
		orders,
		dashboard,
		announcements,
		subsidies,
		customQuestions,
		inquiryForm,
		ui,
		users,
		bulkEdit,
		rallyIntelligence,
		cateringBot,
		enterpriseMenuPull: createBulkJobModule({ basePath: '/restaurants/menu-pull', defaultSortBy: 'startedAt' }),
		menuReplication: createBulkJobModule({ basePath: '/menus/replication', defaultSortBy: 'startedAt' }),
		bulkItemEdit: createBulkJobModule({ basePath: '/multi-location/menu-items/bulk-edit', defaultSortBy: 'startedAt' }),
		bulkTagCreate: createBulkJobModule({ basePath: '/multi-location/tags', defaultSortBy: 'startedAt' })
	}
};
export default new Vuex.Store<RootState>(store);